export const en = {
    'cant-adjust-phrase': "Based on our search statistics, this keyword can't be refined using negative keywords.",
    'count-views-per-month': 'impressions per month',
    'load-more': 'Load more',
    'minus-word-header': 'Negative keywords',
    'minus-word-request-example-header': 'Examples of searches with the negative keyword',
    'phrase-adjustment-info-line-1': 'Select negative keywords to refine the keyword.',
    'phrase-adjustment-info-line-2': 'Ads will not be served for searches that contain a negative keyword.',
    'shows-per-mounth': 'Impression forecast per month: {shows}'
};
